import axios from "axios";

export const commonSendEmail = (requestInfo) => {
    var data = requestInfo;
    // console.log(data)
    const config = {
      method: "POST",
      url: apiURL + "SendEmail/Sendmail",
      headers: { "Content-Type": "application/json" },
      data: data,
    };
    axios(config)
      .then((result) => {
        if (result.status == 200) {
          console.log("")
        } else {
          console.log("")
        }
      })
      .catch(function (error) {
        console.log("")
      });
};
